import {
	type DraftEmissionValuesLocation,
	type DraftManufacturingLocation,
	type EmissionValuesLocation,
	EmissionValuesLocationLocationTypeEnum,
	type ManufacturingLocation,
} from '@api-client'
import type { TFunction } from 'i18next'

const returnEFLocation = (
	t: TFunction,
	values?:
		| EmissionValuesLocation
		| DraftEmissionValuesLocation
		| ManufacturingLocation
		| DraftManufacturingLocation
): string => {
	if (!values) {
		return '-'
	}
	if (values.locationType === EmissionValuesLocationLocationTypeEnum.COUNTRY) {
		return t('location.country.name', { context: values.country })
	}
	if (values.locationType === EmissionValuesLocationLocationTypeEnum.REGIONAL) {
		return t('location.region.name', { context: values.region })
	}
	if (values.locationType === EmissionValuesLocationLocationTypeEnum.GLOBAL) {
		return t('location.global')
	}
	if (values.locationType === EmissionValuesLocationLocationTypeEnum.SITE) {
		return t('location.site')
	}
	return '-'
}

export { returnEFLocation }
